export default __webpack_public_path__ + "static/media/exploded-view_labels.0730a16a.png";